import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { take } from "rxjs";
import { RxjsHelper } from "../../../../../../components/common/utils/rxjs-helper";

/**
 * Assigns/unassigns properties from/to portfolio
 */
export class AssignPropertiesToPortfolioGridActionHandler extends GridActionHandlerBase {
  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(payload: any): void {
    const grid = this.workspace.grid;
    const postUrl = this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Properties/setPortfolioId`);

    const url = (payload) => `${postUrl}?propertyId=${payload.propertyId}&portfolioId=${payload.portfolioId}&projectId=${payload.projectId}`

    grid.loading = true;
    if (!Array.isArray(payload)) {
      //single assign/unassign
      this.http.post(url(payload), {}).pipe(take(1)).subscribe({
        next: () => {
          grid.loading = false;
          this.eventBus.broadcastEvent('PropertyLoadData');
        }, error: () => {
          grid.loading = false;
        }
      });
    } else {
      //array => multiple assigns/unassigns
      const promises = payload.map(payload => RxjsHelper.toPromise(this.http.post(url(payload), {})));
      Promise.all(promises).then(() => {
        grid.loading = false;
        this.eventBus.broadcastEvent('propertiesDataSaved');
      }).catch(() => {
        grid.loading = false;
      });
    }
  }
}
